export default __webpack_public_path__ + "static/media/WeekCardHarbor1.65f141db.jpg";